module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperSmooth-0c88fec10c251ffca54f709d67f68ae2.jpg";